module.exports = __webpack_public_path__ + "static/media/26.6e517805.jpg";